<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .candidate-item {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(4px);

    .candidate-info {
      @include colors.color(textGrey);
      @include mixins.caption();
    }
  }
</style>

<script>
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import AutocompleteInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/AutocompleteInput.svelte";
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { queryCandidates } from "@sourcewhale/shared/src/svelte/api/candidates";

  let { candidateId = $bindable(null), style, ...restProps } = $props();

  // State
  let searchValue = $state("");
  let suggestions = $state([]);
  let isSearching = $state(false);
  let show = $state(false);

  let searchTimeout;
  const searchContacts = async (value) => {
    if (!value || value.length < 2) {
      suggestions = [];
      return;
    }

    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(async () => {
      isSearching = true;
      try {
        const res = await queryCandidates({
          search: { value: value.trim(), regex: false },
          columns: [
            {
              name: "",
              search: { value: "", regex: false },
              data: "candidateId",
              searchable: true,
              orderable: false,
            },
          ],
          tagIds: [],
          start: 0,
          length: 10,
          stages: [],
          allTagsMustMatch: false,
          campaignIds: [],
          draw: 1,
          order: [{ column: 0, dir: "asc" }],
          sourcerUserIds: "",
          status: "",
        });
        suggestions =
          res && res.data
            ? res.data.map((x) => ({
                id: x.candidateId,
                label: x.name,
                data: x,
              }))
            : [];
      } catch {
        suggestions = [];
        showToast({
          title: "Search error",
          subtitle: "Please try again",
          type: "danger",
        });
      } finally {
        isSearching = false;
      }
    }, 300);
  };

  const handleSelect = (suggestion) => {
    candidateId = suggestion.data.candidateId;
    searchValue = suggestion.label;
    show = false;
  };

  const handleFocus = () => {
    show = true;
  };

  const handleBlur = () => {
    setTimeout(() => {
      show = false;
    }, 200);
  };
</script>

<AutocompleteInput
  bind:value={searchValue}
  placeholder="Search contacts by name..."
  minChars={2}
  isLoading={isSearching}
  onInput={searchContacts}
  bind:show
  {suggestions}
  {handleSelect}
  {handleFocus}
  {handleBlur}
  {style}
  {...restProps}
>
  <ListItem
    slot="item"
    let:suggestion
    let:selected
    let:select
    src={suggestion.data?.photo || ""}
    alt={suggestion.label}
    {selected}
    onclick={() => select(suggestion)}
    imgStyle="align-self: flex-start"
  >
    <div class="candidate-item">
      <span>{suggestion.label}</span>
      {#if suggestion.data?.role || suggestion.data?.company}
        <span class="candidate-info">
          {[suggestion.data?.role, suggestion.data?.company]
            .filter(Boolean)
            .join(", ")}
        </span>
      {/if}
    </div>
  </ListItem>
</AutocompleteInput>
